import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useOrderDetail = (id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const order = sharedRef(null, `orderDetail-${id}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `orderDetail-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `orderDetail-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const orderOne = async (params: CustomQuery) => {
    try {
      loading.value = true;
      order.value = null;
      const res = await context.$xbuy.api.orderDetail(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        order.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
      return res;
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    orderOne: orderOne,
    order: computed(() => order.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
